import type { RouteSectionProps } from "@solidjs/router";
import Nav from "../components/Nav";

export default function PageLayout(props: RouteSectionProps) {
  return (
    <div class="flex flex-col min-h-dvh">
      <Nav />
      {props.children}
    </div>
  );
}
